import request from '@/utils/request'

export function ShenZhen(num, data) {
  return request({
    url: `/report/${num}`,
    method: 'GET',
    data
  })
}

/*简报*/
export function getBriefingList(data) {
  return request({
    url: '/briefing/list',
    method: 'POST',
    data
  })
}

/*新增*/
export function visitAdd(data) {
  return request({
    url: '/report/traffic/add',
    method: 'POST',
    data
  })
}

